import { api } from './api'

/**
 * The notifications section (B4): the server's inbox, its read state and
 * the five channel switches. Rows are made by the server on events — a
 * scored attempt, later feed and payment events — never by a client.
 */

export async function listNotifications() {
  const { data } = await api.get('/notifications/list')
  return data
}

/** Marks the given rows read, or everything with `all`; answers the unread count after. */
export async function markNotificationsRead({ ids, all } = {}) {
  const { data } = await api.post('/notifications/mark-read', all ? { all: true } : { ids: ids ?? [] })
  return data
}

export async function notificationPreferences() {
  const { data } = await api.get('/notifications/preferences')
  return data
}

/** Only the switches present change. */
export async function updateNotificationPreferences(changes) {
  const { data } = await api.post('/notifications/update-preferences', changes)
  return data
}
